module.exports = __webpack_public_path__ + "static/media/collapse.971b3869.svg";